import React from 'react';
import styles from './style.less';
import { Button, Progress } from 'antd';
import { CheckCircleOutlined, EnterOutlined } from '@ant-design/icons';
import { Brand_Logo } from '@/utils/uiHelper';
import { SyncStatus } from './index';

export type SyncUIProp = {
  progressPercent: number;
  messages: { text: string; type?: string }[];
  ready: SyncStatus;
  onRequestEnterSystem: () => void;
};

const SyncUI: React.FC<SyncUIProp> = ({
  progressPercent,
  messages,
  ready,
  onRequestEnterSystem,
}: SyncUIProp) => {
  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <div className={styles.content}>
          <h2 className={styles.title}>POS 数据同步</h2>

          <div className={styles.console}>
            {messages.map((message, index) => (
              <div key={index}>
                <CheckCircleOutlined style={{ color: '#52c41a' }} /> {message.text}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.logo}>
          <img draggable={false} src={Brand_Logo} alt={'logo'} />
          <Progress
            showInfo={false}
            type={'line'}
            percent={progressPercent}
            status={progressPercent >= 100 ? 'success' : 'active'}
          />
          <div className={`${styles.ready} ${ready === SyncStatus.DONE ? styles.done : ''}`}>
            <Button
              className={styles.readyBtn}
              ghost
              size={'large'}
              onClick={() => {
                onRequestEnterSystem();
              }}>
              进入系统 <EnterOutlined />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SyncUI;
